const report = [{
  desc: '机构业务统计查询接口',
  options: {
    url: '/report/getInsBranchOrgStatistics',
    method: 'post'
  },
  vuex: false
}, {
  desc: '保费、收入、支出、利润统计查询接口',
  options: {
    url: '/report/getInsStatistics',
    method: 'post'
  },
  vuex: false
}, {
  desc: '业务概况统计查询接口',
  options: {
    url: '/report/getInsSummary',
    method: 'post'
  }
}, {
  desc: '收入汇总查询接口',
  options: {
    url: '/report/getInsSettleSumStatistics',
    method: 'post'
  }
}, {
  desc: '总保费和净佣金趋势接口',
  options: {
    url: '/report/getInsStatisticsForJSC',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '业务员业务统计查询接口',
  options: {
    url: '/report/getInsSalesmanStatistics',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '分支机构保费排名前10',
  options: {
    url: '/report/getInsBranchOrgStatisticsForJSC',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '保单数量、保单保额、净佣金汇总查询接口',
  options: {
    url: '/report/queryInsuranceSumForJSC',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '保费分布统计查询接口',
  options: {
    url: '/report/getInsPremiumStatistics',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '保单量分布统计查询接口',
  options: {
    url: '/report/getInsCountStatistics',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '实时出单监控接口',
  options: {
    url: '/report/getOutInsStatistics',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '组织分布图-按机构类型接口',
  options: {
    url: '/report/getOrgDistributionStatistics',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '组织分布图-按分支机构接口',
  options: {
    url: '/report/getOrgDistributionBranchStatistics',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '手续费结算情况',
  options: {
    url: '/report/getInsSettleSumStatisticsForJsc',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '组织效率趋势',
  options: {
    url: '/report/getOrgEfficiencyForJsc',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '分支机构利润贡献度接口',
  options: {
    url: '/report/getOrgProfitContributionStatistics',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '机构活跃度接口',
  options: {
    url: '/report/getOrgActiveStatistics',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '人员活跃度接口',
  options: {
    url: '/report/queryCustomerLoginStatisticsForJsc',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '人员、机构活跃率',
  options: {
    url: '/report/queryCustomerAndOrgStatistics',
    method: 'post',
    showLoading: false // 是否显示loading框
  }
}, {
  desc: '佣金查询',
  options: {
    url: '/report/commissionInquiry',
    method: 'post'
  }
}, {
  desc: '佣金查询导出',
  options: {
    url: '/report/commissionInquiryExport',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '财务报表查询',
  options: {
    url: '/report/queryFinanceReport',
    method: 'post'
  }
}, {
  desc: '财务报表导出',
  options: {
    url: '/report/financeReportExcel',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '业务报表查询',
  options: {
    url: '/report/queryBusinessReport',
    method: 'post'
  }
}, {
  desc: '业务报表导出',
  options: {
    url: '/report/businessReportExcel',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '创建分支机构监管报表导出任务',
  options: {
    url: '/report/addRegulatoryReportExportTask',
    method: 'post'
  }
}]
export default report



// WEBPACK FOOTER //
// ./src/api/report.js